import React, { useState, useEffect } from 'react';
import styles from '../BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

let checkAll = false;
let hasFirstRender = false;
const BasicSuperfundNonNPLFilter = (props) => {
    const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
    const [checkAllCheckbox, setCheckAllCheckbox] = useState<Array<any>>([]);
    const options = {
        "Assessment Needed or Ongoing": {
            param: "SF_NON_NPL_STATUS_SUBCATEG ='Additional Assessment Needed/Ongoing'",
            isIncluded: false,
            objectIds: null
        },
        "Not Eligible for the NPL/No Further Remedial Action Planned": {
            param: "SF_NON_NPL_STATUS_CATEGORY = 'Not Eligible for the NPL/No Further Remedial Action Planned'",
            isIncluded: false,
            objectIds: null
        },
        "Referred to Cleanup Program": {
            param: "SF_NON_NPL_STATUS_CATEGORY = 'Referred to Cleanup Program' AND SF_NON_NPL_CODE <> ''",
            isIncluded: false,
            objectIds: null
        },
        "Ready for Anticipated Use": {
            param: "SF_READY_FOR_REUSE_IND = 'Y' AND SF_NON_NPL_CODE <> ''",
            isIncluded: false,
            objectIds: null
        }
    }

    const toggleAll = () => {
        // switch checkAll
        checkAll = !checkAll;
        for (let option in options) {

            if (checkAll) {
                // set all isIncludeds to false so they can be set to true from buildCheckBoxDivs()
                options[option]["isIncluded"] = false;
            } else if (!checkAll) {
                // switch all isIncludeds to true so they can be switched back to false by toggleParam()
                options[option]["isIncluded"] = true;
                toggleParam(option);
            }
        }
        buildCheckboxDivs();
    }

    const toggleParam = async (key) => {
        options[key].isIncluded = !options[key].isIncluded;
        passUpdatedParams();
    }

    const passUpdatedParams = () => {
        let paramArray: Array<any> = [];
        for (let option in options) {
            if (options[option].isIncluded === true) {
                paramArray.push(options[option].param)
            }
        }
        props.updateSuperfundNonNPLParams(paramArray);
    }

    const buildCheckAllCheckboxDiv = () => {
        let checkAllDiv;
        if (!checkAll) {
            checkAllDiv =
                <div className={styles.SectionTitleDivs}>
                    <CalciteCheckbox name={"toggleAllSuperfundNonNPL"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
                    <label className={styles.FilterSectionLabels}>Superfund Non-NPL Sites</label>
                </div>;
        } else if (checkAll) {
            checkAllDiv =
                <div className={styles.SectionTitleDivs}>
                    <CalciteCheckbox checked name={"toggleAllSuperfunNondNPL"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
                    <label className={styles.FilterSectionLabels}>Superfund Non-NPL Sites</label>
                </div>;
            // toggleAll();
        }
        setCheckAllCheckbox(checkAllDiv);
    }

    const buildCheckboxDivs = () => {
        let tempArr: Array<any> = [];
        if (!checkAll) {
            for (let key in options) {
                tempArr.push(
                    <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
                        <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
                        <label className={styles.CheckboxLabels}>{key}</label>
                    </div>
                );
            }
        } else if (checkAll) {
            for (let key in options) {
                toggleParam(key);
                tempArr.push(
                    <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
                        <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
                        <label className={styles.CheckboxLabels}>{key}</label>
                    </div>
                );
            }
        }
        setCheckboxDivArray(tempArr);
    }

    useEffect(() => { }, [checkboxDivArray, checkAllCheckbox]);

    useEffect(() => {
        if (props.checkAllBoxes === true) {
            checkAll = true;
        } else if (props.checkAllBoxes === false) {
            if (props.customRouteUsed && hasFirstRender === false) {
                checkAll = true;
                hasFirstRender = true;
                buildCheckAllCheckboxDiv();
                buildCheckboxDivs();
                props.updateDefinitionExpression();
                return;
            } else {
                checkAll = false;
            }
        }
        buildCheckAllCheckboxDiv();
        buildCheckboxDivs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.signalAChange]);

    return (
        <div className={styles.Sections}>
            {checkAllCheckbox}
            <div className={styles.CheckboxSectionDivs}>
                {checkboxDivArray}
            </div>
        </div>
    );

}

export default BasicSuperfundNonNPLFilter;
